import axios from 'axios'
import { dataLayerPushDonationFailed } from './Utility'

export const checkAddressIsValid = (type, values) => {
  return values[`${type}_line_1`] !== '' && values[`${type}_town_city`] !== ''  && values[`${type}_post_code`] !== ''
}

export const replaceTokens = (text, values, giftaidRate) => {
  const giftAidAmount = (parseFloat(values.payment_amount) * giftaidRate).toFixed(2).replace('.00', '')
  const giftAidValue  = ((parseFloat(values.payment_amount) * giftaidRate) - parseFloat(values.payment_amount)).toFixed(2).replace('.00', '')
  return text.replace('{DONATION_AMOUNT}', values.payment_amount).replace('{GIFTAID_AMOUNT}', giftAidAmount).replace('{GIFTAID_VALUE}', giftAidValue)
}

export const billingAddressGet = values => {
  return {
    givenName      : values.first_name ? values.first_name : null,
    surname        : values.last_name ? values.last_name : null,
    phoneNumber    : values.telephone_number ? values.telephone_number : null,
    streetAddress  : values.use_contact_address ? values.contact_address_line_1    : values.billing_address_line_1,
    extendedAddress: values.use_contact_address ? values.contact_address_line_2    : values.billing_address_line_2,
    locality       : values.use_contact_address ? values.contact_address_town_city : values.billing_address_town_city,
    postalCode     : values.use_contact_address ? values.contact_address_post_code : values.billing_address_post_code,
  }
}


export const clientTokenGet = () => {
  return new Promise((resolve, reject) => {
    axios({ method: 'get', url: '/wp-json/wg/v1/braintree-client-token' })
      .then(response => {
        resolve(response.data.client_token)
      })
      .catch(error => {
        reject(`clientTokenGet ${error.response.status}: ${error.response.data.message}`)
      })
  })
}

export const bankDetailsValidate = (accountName, accountNumber, sortCode) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: '/wp-json/wg/v1/bank-details-validate',
      data: {
        account_name  : accountName,
        account_number: accountNumber,
        sort_code     : sortCode
      }
    })
      .then(response => {
        console.log(response)

        resolve({status: response.data.status, message: response.data.message})
      })
      .catch(error => {
        reject(`clientTokenGet ${error.response.status}: ${error.response.data.message}`)
      })
  })
}

export const bankDetailsCheckout = values => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: '/wp-json/wg/v1/pdd-checkout',
      data: values
    })
    .then(response => {
      console.log(response)

      resolve(response.data)
    })
    .catch(error => {
      reject({
        status : error.response.status,
        message: error.response.status === 500 ? 'An unexpected error': error.response.data.message
      })
    })
  })
}

export const braintreeCheckout = values => {
  return new Promise((resolve, reject) => {
    axios(
      {
        method: 'post',
        url   : '/wp-json/wg/v1/braintree-checkout',
        data  : values
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log('error', error)
        reject({
          status : error.response.status,
          ...error.response.data
        })
      })
  })

}

export const dataLayerPushError = error => {
  if (window.dataLayer) {
    const event = {
      event                  : 'donationFailed',
      message                : error.message,
      processorResponseCode  : error.processorResponseCode ? error.processorResponseCode : '',
      processorResponseText  : error.processorResponseText ? error.processorResponseText : '',
      processorResponseType  : error.processorResponseType ? error.processorResponseType : '',
      processorResponseStatus: error.processorResponseStatus ? error.processorResponseStatus : '',
    }

    window.dataLayer.push(event)
  }
}

export const csrfTokenGet = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url   : '/wp-json/wg/v1/csrf-token',
    })
      .then(response => {
        console.log(response)
        resolve(response.data)
      })
      .catch(error => {
        reject({
          status : error.response.status,
          message: error.response.status === 500 ? 'An unexpected error': error.response.data.message
        })
      })
  })
}

export const orderSend = values => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url   : '/wp-json/wg/v1/order',
      data  : values
    })
      .then(response => {
        console.log(response)
        resolve(response.data)
      })
      .catch(error => {
        const err = error.response.data;
        dataLayerPushDonationFailed(err.processorResponseCode, err.processorResponseText);
        let message = err.message;
        if(err.processorResponseCode == 68 && typeof err.processorResponseText == 'string') {
          if (err.processorResponseText == "Sortcode is VALID, Account is INVALID") {
            message += ' - please update your account number';
          } else if (err.processorResponseText == "Sortcode is INVALID, Account is INVALID") {
            message += ' - please update your sort code and account number';
          } else if (err.processorResponseText == "Sortcode is INVALID, Account is VALID"
            || err.processorResponseText == "Sortcode is INVALID, Account cannot be checked assuming VALID") {
            message += ' - please update your sort code';
          }
        }
        reject({
          status : error.response.status,
          message: error.response.status === 500 ? 'An unexpected error': message
        })
      })
  })
}

export const orderUpdate = values => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url   : '/wp-json/wg/v1/order-update',
      data  : values
    })
      .then(response => {
        console.log(response)
        resolve(response.data)
      })
      .catch(error => {
        reject({
          status : error.response.status,
          message: error.response.status === 500 ? 'An unexpected error': error.response.data.message
        })
      })
  })
}
